var _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoogleDrive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3849 68.5688L27.9432 73.002C28.4766 73.935 29.2365 74.6691 30.138 75.1996L39.2713 59.3329H21C21 60.3655 21.2643 61.398 21.7977 62.331L25.3849 68.5688Z",
    fill: "#1967D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 40.6671L40.8667 24.8004C39.9699 25.3356 39.2052 26.065 38.6719 27.0028L21.7977 56.3348C21.2785 57.2442 21 58.2814 21 59.3329H39.2713L50 40.6671Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8667 75.1996C70.7635 74.6644 71.5282 73.935 72.0615 73.0019L73.1236 71.169L78.2071 62.3357C78.7404 61.4027 79.0047 60.3702 79.0047 59.3376H60.7287L64.618 67.0057L69.8667 75.1996Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 40.6671L59.1333 24.8004C58.2365 24.2652 57.2075 24 56.1455 24H43.8545C42.7925 24 41.7635 24.2984 40.8667 24.8004L50 40.6671Z",
    fill: "#188038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7287 59.3329H39.2713L30.138 75.1996C31.0348 75.7348 32.0638 76 33.1258 76H66.8742C67.9362 76 68.9699 75.7017 69.862 75.1996L60.7287 59.3329Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7628 41.6665L61.3281 26.9981C60.7947 26.065 60.0348 25.3309 59.138 24.7957L50.0047 40.6624L60.7287 59.3329H78.9669C78.9669 58.3004 78.7026 57.2679 78.1693 56.3348L69.7628 41.6665Z",
    fill: "#FBBC04"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 52,
    fill: "white",
    transform: "translate(21 24)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleDrive);
export default __webpack_public_path__ + "static/media/GoogleDrive.6e521b07e1bd9bf311e2f22343bae5dc.svg";
export { ForwardRef as ReactComponent };